var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFooterFavourite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFooterFavourite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.657038,17.8049 C130.951938,17.5175 131.056038,17.0957 130.928838,16.7036 C130.801338,16.3115 130.469238,16.0316 130.061238,15.9722 L126.433638,15.4451 C126.279138,15.4226 126.145638,15.3257 126.076638,15.1856 L124.454838,11.8988 C124.272738,11.5295 123.903138,11.3 123.491238,11.3 C123.079638,11.3 122.710038,11.5295 122.527938,11.8988 L120.905838,15.1859 C120.836838,15.326 120.703038,15.4229 120.548538,15.4454 L116.920938,15.9725 C116.513238,16.0316 116.180838,16.3118 116.053338,16.7039 C115.926138,17.096 116.030238,17.5178 116.325138,17.8052 L118.949838,20.3636 C119.061738,20.4728 119.113038,20.63 119.086638,20.7836 L118.467438,24.3962 C118.412538,24.7142 118.495938,25.0235 118.701738,25.2674 C119.021538,25.6475 119.579838,25.7633 120.026238,25.5287 L123.270438,23.8229 C123.406038,23.7518 123.576738,23.7524 123.712038,23.8229 L126.956538,25.5287 C127.114338,25.6118 127.282638,25.6538 127.456338,25.6538 C127.773438,25.6538 128.074038,25.5128 128.280738,25.2674 C128.486838,25.0235 128.569938,24.7136 128.515038,24.3962 L127.895538,20.7836 C127.869138,20.6297 127.920438,20.4728 128.032338,20.3636 L130.657038,17.8049 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Views-Notifications",
    transform: "translate(-298.000000, -580.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(182.000000, 569.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icFooterFavourite",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFooterFavourite);
export default __webpack_public_path__ + "static/media/icFooterFavourite.81b931ec46755903fb42f520decb8007.svg";
export { ForwardRef as ReactComponent };